var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","left":"0","top":"0"}},[_c('button',{staticStyle:{"width":"78px","height":"32px","opacity":"0","cursor":"pointer"},on:{"click":_vm.togglePlay}},[_vm._v(_vm._s(_vm.isPlaying ? '暂停' : '播放'))]),_c('audio',{ref:"audioPlayer",attrs:{"src":_vm.audioUrl,"preload":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }